// 查看关联三段单号 弹框
import { RESPONSE_CODE } from '@public/http/config'
import { detailView } from '@/components/pool'
import { copyText } from '@/common/utils/tool'
import debounce from 'lodash/debounce'

export default {
  data() {
    return {
      errorCodes: [],
      showVirtualTooltip: false,
      virtualCodeList: []

    }
  },
  methods: {
    async getOrderLabel(waybillNo, listName, isArray) {
      const { code, msg, data } = await detailView.getOrderLabelList(waybillNo)
      if (code === RESPONSE_CODE.SUCCESS) {
        // 订单标签名称
        const { lableList, firstWaybill, secondWaybill } = data || {}
        if (this.showConsolidation &&typeof this.getConsolidationTrailList==='function') {
          this.getConsolidationTrailList(firstWaybill, 'firstTrailList')
          this.getConsolidationTrailList(secondWaybill, 'secondTrailList')
        }
        const orderSignList = lableList || []
        // 如果是数组
        if (isArray) {
          this.$set(this[listName][0], 'orderSignList', orderSignList)
        } else {
          this[listName] = {
            ...this[listName],
            orderSignList
          }
        }
      } else {
        this.$message.error(msg)
      }
    },
    orderSignClick: debounce(async function(waybillNo, hasButton) {
      this.getWaybillRelation(waybillNo, hasButton)
    }, 500),
    // 请求弹窗数据
    async getWaybillRelation(waybillNo, type) {
      this.errorCodes = []
      try {
        const { code, data, msg } = await detailView.getWaybillRelation({ waybillNo, type })
        if (code === RESPONSE_CODE.SUCCESS) {
          if (data) {
            this.errorCodes = []
            Object.keys(data || {})?.forEach((key) => {
              // 点击集运二段 出现一段和三段
              if (key !== type) {
                this.errorCodes.push(key)
                this.errorCodes.push(data[key])
              }
            })
            this.errorCodesConfirm(this.errorCodes)// 打开弹窗
          }
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.log('111', e)
      }
    },
    // 弹窗
    errorCodesConfirm(errorCodes) {
      const listMap = { 'firstNo': '关联一段', 'secondNo': '关联二段', 'thirdNo': '关联三段' }
      // 1.创建虚拟节点
      const h = this.$createElement
      const newDatas = []
      let newValue = ''
      // 2.循环输出数组的每条信息
      for (const i in errorCodes) {
        if (listMap[errorCodes[i]]) {
          newDatas.push(h('div', null, listMap[errorCodes[i]]))
          newValue += listMap[errorCodes[i]] + '\n'
        } else {
          newDatas.push(h('p', null, errorCodes[i]?.join(' ')))
          newValue += errorCodes[i]?.join(' ') + '\n'
        }
        // 将数组中的每条信息进行用p标签填充
      }
      this.$confirm(this.$lang(``), this.$lang('查询关联单号'), {
        confirmButtonText: this.$lang('复制'),
        cancelButtonText: this.$lang('关闭'),
        message: h('div', null, newDatas),
        // showCancelButton: false,
        confirmButtonClass: 'comfirm-btn',
        customClass: 'associated_three_tag_codes_prompt'
      }).then(() => {
        copyText(newValue)
      }).catch(() => {

      })
    },
    // 请求虚拟号接口
    async virtualNumberClick(waybillNo, orderSourceCode) {
      this.virtualCodeList = ''
      const { title: menuName } = this.$route.query
      const { title: menuNameMeta } = this.$route.meta
      try {
        const { code, data, msg } = await detailView.privateNumberQuery({ waybillNo, orderSourceCode, menuName: menuName || menuNameMeta })
        if (code === RESPONSE_CODE.SUCCESS) {
            this.virtualCodeList = data||'--'
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.log('111', e)
      }
    },
    handleCopy(text) {
      copyText(text)
    }
  },
  computed:{
    showConsolidation() {
      return ['callCenter', 'imService'].includes(this.$route.name)
    },
  }
}
